var map = {
  "./check-icon.svg": "10392",
  "./custom-export-360-fullcontent.svg": "111778",
  "./custom-export-by_reviewee.svg": "566390",
  "./custom-export-by_reviewer.svg": "996296",
  "./custom-export-objectives-by_objective.svg": "402371",
  "./custom-export-objectives-by_user.svg": "646984",
  "./custom-export-objectives-fullcontent.svg": "558922",
  "./loading-spinner.svg": "735221",
  "./module-reviews-icon.svg": "932326",
  "./move-objective-icon.svg": "877477",
  "./plus.svg": "948379"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 504768;
